var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-edit',{attrs:{"autoValidate":""},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"recPayData":_vm.recPayData,"userData":_vm.userData}}),_c('RecPay',{attrs:{"recPayData":_vm.recPayData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }